import { LOCALES, LOCALE_META, type Locale } from '../../i18n'
import { useLocale } from '../../contexts/LocaleContext'

export default function LanguagePicker() {
  const { locale, setLocale, t } = useLocale()

  return (
    <div className="lucky-lang" role="group" aria-label={t('profile.language')}>
      {LOCALES.map((code: Locale) => (
        <button
          key={code}
          type="button"
          className={`lucky-lang__btn${locale === code ? ' is-on' : ''}`}
          onClick={() => setLocale(code)}
          lang={code}
          dir={LOCALE_META[code].dir}
          aria-pressed={locale === code}
        >
          {LOCALE_META[code].nativeLabel}
        </button>
      ))}
    </div>
  )
}
